import { ConnectionDetails, convertConnectionToDetails, handleError, mergeConnectionDetails } from '../../../utils/custom';
import { Import, ImportConnection, ImportWithAirportConnectionInput, ImportWithAirportSearch } from '../../../models/gen/graphql';
import { SEARCH_IMPORTS_PAGE_SIZE, SearchImportOptions } from './searchImports';

import { GraphApiResponse } from '../../core';
import { SearchImportHistoryTableDocument } from '../../queries';
import createGraphApiHook from '../../../hooks/createGraphApiHook';
import graphApi from '../..';

type SearchImportHistoryTableGraphApiResponse = GraphApiResponse<typeof SearchImportHistoryTableDocument>;

const title = 'Search Import History';

const searchImportHistoryTableResponseSelector = (res: SearchImportHistoryTableGraphApiResponse): ConnectionDetails<Import> =>
  convertConnectionToDetails(res?.searchImports?.importWithAirportConnection as ImportConnection);

const [runSearchImportHistoryTable, runRefetchSearchImportHistoryTable] = graphApi(SearchImportHistoryTableDocument, {
  onError: (res: SearchImportHistoryTableGraphApiResponse): void => handleError(res, { notification: { title } }),
});

const searchImportHistoryTable = async (
  query: ImportWithAirportSearch[],
  options: SearchImportOptions = {}
): Promise<ConnectionDetails<Import>> => {
  const { pageSize = SEARCH_IMPORTS_PAGE_SIZE, page = 0, merge = false } = options;

  const input: ImportWithAirportConnectionInput = {
    first: pageSize || null,
    after: pageSize ? (pageSize * page).toString() : null,
    query,
  };
  const graphApiOptions = { merge: merge ? 'searchImports.importWithAirportConnection' : undefined };

  const res = await runSearchImportHistoryTable({ input }, graphApiOptions);

  return searchImportHistoryTableResponseSelector(res);
};

const refetchSearchImportHistoryTable = async (
  query: ImportWithAirportSearch[],
  options: SearchImportOptions = {}
): Promise<ConnectionDetails<Import>> => {
  const { pageSize = SEARCH_IMPORTS_PAGE_SIZE, page = 0 } = options;

  const input: ImportWithAirportConnectionInput = {
    first: pageSize || null,
    after: pageSize ? (pageSize * page).toString() : null,
    query,
  };

  const res = await runRefetchSearchImportHistoryTable({ input });

  return searchImportHistoryTableResponseSelector(res);
};

export const useSearchImportHistoryTable = createGraphApiHook(searchImportHistoryTable, {
  refetch: refetchSearchImportHistoryTable,
  merge: mergeConnectionDetails,
});

export default searchImportHistoryTable;
